function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Result from './result'; // @namespace Model

var DiscourseResult = /*#__PURE__*/function (_Result) {
  _inheritsLoose(DiscourseResult, _Result);

  function DiscourseResult() {
    return _Result.apply(this, arguments) || this;
  }

  var _proto = DiscourseResult.prototype;

  _proto.feature = function feature() {
    return this.poll().toggle('featured_result_id', {}, this.id);
  };

  _proto.unfeature = function unfeature() {
    return this.poll().toggle('featured_result_id', {}, null);
  };

  _proto.unapprove = function unapprove() {
    return this.save({
      approved: false
    });
  };

  _proto.isUnapproved = function isUnapproved() {
    return this.get('approved') === false;
  };

  return DiscourseResult;
}(Result);

export { DiscourseResult as default };